import { List, ListProps } from '@mui/material';

const ListWrapper: React.FC<ListProps> = (props) => <List {...props} />;

export default ListWrapper;
